import Section from "../Section";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import AdminTable, { cellClass } from "../Admin/AdminTable";
import { getAllUsers } from "../../helpers/lib/axios";
import { useApiList } from "../../helpers/lib/useApiData";

const Users = () => {
    const { items, loading, error } = useApiList(getAllUsers, 'Failed to load users.');

    return (<>
        <BannerSectionStyle2
            bgUrl="/images/about/banner_bg.svg"
            imgUrl="/images/about/banner_img.png"
            title="Users"
            subTitle="User information"
        />
        <Section
            topMd={170}
            topLg={150}
            topXl={110}
            bottomMd={200}
            bottomLg={150}
            bottomXl={110}
            className='flex justify-center items-center w-full'
        >
            <div className="lg:max-w-[70%] w-full mt-[5%] p-4">
                <AdminTable
                    columns={['Name', 'Email', 'Gender', 'Admin']}
                    items={items}
                    loading={loading}
                    error={error}
                    emptyText="No users yet."
                    getKey={(user) => user?._id ?? user?.id}
                    renderRow={(user) => (<>
                        <td className={cellClass}>{[user?.firstName, user?.lastName].filter(Boolean).join(' ')}</td>
                        <td className={cellClass}>{user?.email}</td>
                        <td className={cellClass}>{user?.gender}</td>
                        <td className={cellClass}>{user?.isAdmin ? "True" : "False"}</td>
                    </>)}
                />
            </div>
        </Section>
    </>);
}

export default Users;
